function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHsLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 43 43",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    style: {
      backgroundColor: "transparent"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "elements",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "elements-wrapper"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect-uqmkd3c28n",
    fill: "rgb(1,197,252)",
    width: 41.6,
    height: 41.6,
    rx: 5,
    ry: 5,
    stroke: "none",
    strokeWidth: 0,
    transform: "translate(0.6 1)",
    style: {
      mixBlendMode: "normal",
      paintOrder: "fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "LoadingPath",
    d: "M15.52658,15.19883C18.299155,10.100876,25.463441,9.078712,28.89753,12.962885C31.759539,16.199999,31.759539,18.999999,31.759539,18.999999C31.759539,18.999999,33.51205,19.081744,34.17435,19.22353C36.4,19.699999,39.22362,23.6139,37.48355,27.09405C35.08951,31.88213,30.87457,31.66103,26.84046,29.24056C21.91086,26.28279,15.22304,15.49043,8.461,19.17881C2.5477,22.40425,4.27922,30.98677,10.96526,31.65538C13.7593,31.93479,16.14041,29.56584,17.89669,27.80956",
    fill: "none",
    stroke: "rgb(255,255,255)",
    strokeWidth: 2.5,
    strokeDasharray: "94.74 70",
    style: {
      mixBlendMode: "normal",
      paintOrder: "fill"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHsLogo2);
export default __webpack_public_path__ + "static/media/HSLogo2.7d64c814fa150c95bdc24100ad07c624.svg";
export { ForwardRef as ReactComponent };